import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Icon } from './atoms';

const template = styled.div`
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Select',
      displayValue: ({ icon }) => icon,
    },
  ]
})